import * as React from 'react';
export const folderSvg = React.forwardRef(function folderSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16 7.827c0 .114-.02.228-.058.336l-1.968 5.51A2 2 0 0 1 12.091 15H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2.586a1 1 0 0 1 .707.293L6 2h5a2 2 0 0 1 2 2v1h1a2 2 0 0 1 2 2v.827ZM3.75 6.5a.75.75 0 0 1 0-1.5h7.75V4a.5.5 0 0 0-.5-.5H6a1.5 1.5 0 0 1-1.06-.44l-.561-.56H2a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10.09a.5.5 0 0 0 .471-.332L14.5 7.74V7a.5.5 0 0 0-.5-.5H3.75Z',
    }),
  );
});
folderSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var folder = {
  category: 'icon',
  colorable: true,
  name: 'folder',
  svg: folderSvg,
};
